/******************************************************************************
 * AdminWorkorderToolsTab: super-admin maintenance actions on a single work
 * order, addressed by id. Endpoints (core, app module):
 *   PUT admin/workorders/resend/{id}    -> force the phone to (re)upload the WO
 *   PUT admin/workorders/unpending/{id} -> clear the "pending" flag on the WO
 *****************************************************************************/

/* Imports */
import { ArrowPathIcon, FlagIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";
/***/

/* Components */
import ToolActionCard from "../../components/ToolActionCard";
import WorkorderSearchSelect from "../../components/WorkorderSearchSelect";
/***/

/* Services */
import { api } from "../../../../../../services/api/api";
/***/

/**
* AdminWorkorderToolsTab: work order admin tools
*/
export default function AdminWorkorderToolsTab() {
  /**
  * workorderPicker: searchable work order input reused by every card
  */
  const workorderPicker = ({ value, setValue, disabled }: { value: string, setValue: (v: string) => void, disabled: boolean }) => (
    <WorkorderSearchSelect value={value}
      onChange={setValue}
      disabled={disabled}
      placeholder={t("admin:tools.workorders.searchPlaceholder")} />
  );

  return (
    <div className="grid gap-6 md:grid-cols-2 my-4">
      <ToolActionCard
        icon={<ArrowPathIcon className="w-5 text-blue-500" />}
        title={t("admin:tools.workorders.resend.title")}
        notice={t("admin:tools.workorders.resend.notice")}
        buttonLabel={t("admin:tools.workorders.resend.button")}
        successMessage={t("admin:tools.workorders.resend.success")}
        errorMessage={t("admin:tools.workorders.resend.error")}
        requiredMessage={t("admin:tools.workorders.noWorkorder")}
        renderInput={workorderPicker}
        onRun={(id) => api.put("admin/workorders/resend/" + id, {})} />

      <ToolActionCard
        icon={<FlagIcon className="w-5 text-blue-500" />}
        title={t("admin:tools.workorders.unpending.title")}
        notice={t("admin:tools.workorders.unpending.notice")}
        buttonLabel={t("admin:tools.workorders.unpending.button")}
        successMessage={t("admin:tools.workorders.unpending.success")}
        errorMessage={t("admin:tools.workorders.unpending.error")}
        requiredMessage={t("admin:tools.workorders.noWorkorder")}
        renderInput={workorderPicker}
        onRun={(id) => api.put("admin/workorders/unpending/" + id, {})} />
    </div>
  );
}
/***/
